import * as z from "zod/mini";
import { secureString, secureEmail } from "./secure";

export const signUpSchema = z.object({
  name: secureString(1, 80),
  email: secureEmail(),
  password: z.string().check(z.minLength(8, "Must be at least 8 characters"), z.maxLength(128)),
});

export const loginSchema = z.object({
  email: secureEmail(),
  password: z.string().check(z.minLength(1, "Password is required")),
});

export const forgotPasswordSchema = z.object({
  email: secureEmail(),
});

export const resetPasswordSchema = z
  .object({
    password: z.string().check(z.minLength(8, "Must be at least 8 characters"), z.maxLength(128)),
    confirmPassword: z.string(),
  })
  .check((ctx) => {
    if (ctx.value.password !== ctx.value.confirmPassword) {
      ctx.issues.push({
        code: "custom",
        message: "Passwords do not match",
        path: ["confirmPassword"],
        input: ctx.value,
      });
    }
  });

export type SignUpInput = z.infer<typeof signUpSchema>;
export type LoginInput = z.infer<typeof loginSchema>;
export type ForgotPasswordInput = z.infer<typeof forgotPasswordSchema>;
export type ResetPasswordInput = z.infer<typeof resetPasswordSchema>;
